import { render, staticRenderFns } from "./Proctology.vue?vue&type=template&id=7f176f02&scoped=true"
import script from "./Proctology.vue?vue&type=script&lang=js"
export * from "./Proctology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f176f02",
  null
  
)

export default component.exports